import { toast } from "react-toastify";

const initState = {
  profile:
    localStorage.getItem("businessprofile") === "undefined"
      ? null
      : JSON.parse(localStorage.getItem("businessprofile")),
  region:
    localStorage.getItem("businessregion") === "undefined"
      ? null
      : JSON.parse(localStorage.getItem("businessregion")),
  systemuser: null,
  banks: [],
  loading: false,
  banksloading: false,
  suserloading: false,
  regionloading: false,
  //JSON.parse(localStorage.getItem("banks") || "[]"),
  // localStorage.getItem("systemuser") === "undefined"
  //     ? null
  //     : JSON.parse(localStorage.getItem("systemuser")),
};

const profileReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_BUSINESS_PROFILE":
      localStorage.setItem("businessprofile", JSON.stringify(action.payload));
      return {
        ...state,
        profile: action.payload,
        loading: false,
      };

    case "CLEAR_BUSINESS_PROFILE":
      localStorage.removeItem("businessprofile");
      localStorage.removeItem("businessregion");
      return {
        ...state,
        profile: null,
        region: null,
        systemuser: null,
        banks: [],
        loading: false,
      };
    case "GET_SYSTEM_ACCOUNT":
      localStorage.setItem("businessregion", JSON.stringify(action.payload));
      return {
        ...state,
        region: action.payload,
        loading: false,
        regionloading: false,
      };
    case "GET_SYSTEM_ACCOUNT_ERROR":
      toast.error("Please Refresh the Page");
      console.log(action.payload.toString());
      localStorage.removeItem("businessregion");
      return {
        ...state,
        loading: false,
        regionloading: false,
      };
    case "GET_SYSTEM_USER":
      return {
        ...state,
        systemuser: action.payload,
        loading: false,
        suserloading: false,
      };
    case "GET_SYSTEM_USER_ERROR":
      toast.error("Please Refresh the Page");
      console.log(action.payload.toString());
      return {
        ...state,
        banks: [],
        systemuser: null,
        loading: false,
        suserloading: false,
      };
    case "GET_DEPOSIT_BANKS":
      return {
        ...state,
        banks: action.payload,
        loading: false,
        banksloading: false,
      };
    case "GET_DEPOSIT_BANKS_ERROR":
      toast.error("Please Refresh the Page");
      console.log(action.payload.toString());
      return {
        ...state,
        banks: [],
        loading: false,
        banksloading: false,
      };
    case "LOADING_PROFILE":
      return {
        ...state,
        loading: true,
      };
    case "LOADING_SYSTEM_USER":
      return {
        ...state,
        suserloading: true,
      };
    case "LOADING_BANKS":
      return {
        ...state,
        banksloading: true,
      };
    case "LOADING_REGION":
      return {
        ...state,
        regionloading: true,
      };
    default:
      return state;
  }
};

export default profileReducer;
